<template>
  <!--
    	作者：luoyiming
    	时间：2020-04-26
    	描述：门店-添加门店
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form
      size="small"
      ref="dataForm"
      :model="form"
      label-width="120px"
      :rules="rules"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="分类管理" name="first">
          <el-form-item label="一级分类名称" prop="name">
            <el-input
              v-model="form.name"
              placeholder="请输入一级分类名称"
              class="max-w460"
            ></el-input>
          </el-form-item>
          <el-form-item label="分类排序">
            <el-input
              type="number"
              v-model="form.sort"
              placeholder="请输入序号"
              class="max-w460"
            ></el-input>
          </el-form-item>
          <el-form-item label="封面图片" prop="image_id">
            <el-row>
              <el-button
                icon="el-icon-picture-outline"
                @click="openUpload($event, '1')"
                >选择图片</el-button
              >
              <div v-if="form.image_id != ''" class="img">
                <img :src="file_path" width="100" height="100" />
              </div>
            </el-row>
          </el-form-item>
          <el-form-item label="中盒图片" prop="detail_image_id">
            <el-row>
              <el-button
                icon="el-icon-picture-outline"
                @click="openUpload($event, '2')"
                >选择图片</el-button
              >
              <div v-if="form.detail_image_id != ''" class="img">
                <img :src="detail_file_path" width="100" height="100" />
              </div>
            </el-row>
          </el-form-item>
          <el-form-item label="详情页" prop="lottery_image_id">
            <el-row>
              <el-button
                icon="el-icon-picture-outline"
                @click="openUpload($event, '3')"
                >选择图片</el-button
              >
              <span style="color: gray">(请上传尺寸宽高470*690的图片)</span>
              <div v-if="form.lottery_image_id != ''" class="img">
                <img :src="lottery_image" width="156" height="230" />
              </div>
            </el-row>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="抽盒配置" name="second">
          <el-form-item label="销售状态：">
            <el-radio-group v-model="form.state">
              <el-radio :label="1">立即上架</el-radio>
              <el-radio :label="0">放入仓库</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="价格类型：">
            <el-radio-group v-model="form.show_type"  @change="changeShowType">
              <el-radio :label="1">点券</el-radio>
              <el-radio :label="2">积分</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="点券价格：" width="80" v-if="form.show_type === 1" prop="bonds_price">
            <el-input
              type="number"
              v-model="form.bonds_price"
              class="max-w460"
            ></el-input>
          </el-form-item>

          <el-form-item label="积分价格：" width="80" v-if="form.show_type === 2" prop="point_num">
            <el-input
              type="number"
              v-model="form.point_num"
              class="max-w460"
            ></el-input>
          </el-form-item>

          <el-form-item label="抽卡个数：" width="80" prop="draw_counts">
            <el-input
              v-model="form.draw_counts"
              class="max-w460"
              placeholder="输入数字用,隔开如：输入1,2 为1连抽,2连抽"
            ></el-input>
          </el-form-item>
          <el-form-item label=" 隐藏款阈值：" width="80" prop="threshold">
            <el-input type="number" v-model="form.threshold" class="max-w460"></el-input>
          </el-form-item>

          <!--          <el-form-item label="大保底类型：" width="80" prop="jackpot">-->
          <!--            <el-select-->
          <!--              v-model="form.jackpot"-->
          <!--              multiple-->
          <!--              placeholder="请选择大保底类型"-->
          <!--            >-->
          <!--              <el-option-->
          <!--                v-for="item in childCateList"-->
          <!--                :key="item.key"-->
          <!--                :label="item.label"-->
          <!--                :value="item.value"-->
          <!--              />-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->

          <!--          <el-form-item-->
          <!--            label="大保底重置张数："-->
          <!--            width="80"-->
          <!--            prop="jackpot_reset_num"-->
          <!--          >-->
          <!--            <el-input-->
          <!--              type="number"-->
          <!--              v-model="form.jackpot_reset_num"-->
          <!--              class="max-w460"-->
          <!--              placeholder="多少张能出一个大保底"-->
          <!--            ></el-input>-->
          <!--          </el-form-item>-->

          <!--          <el-form-item label="十连抽保底类型：" width="80" prop="ten_reward">-->
          <!--            <el-select-->
          <!--              v-model="form.ten_reward"-->
          <!--              multiple-->
          <!--              placeholder="请选择十连抽保底类型"-->
          <!--            >-->
          <!--              <el-option-->
          <!--                v-for="item in childCateList"-->
          <!--                :key="item.key"-->
          <!--                :label="item.label"-->
          <!--                :value="item.value"-->
          <!--              />-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <!-- <el-form-item label="库存：" width="80" prop="stock">
        <el-input type="number" v-model="form.stock" class="max-w460"></el-input>
      </el-form-item> -->

          <el-form-item label="规则说明" prop="rule_description">
            <!-- <el-input type="textarea" v-model="form.rule_description" class="max-w460"></el-input> -->
            <div class="edit_container">
              <Uediter
                :text="form.rule_description"
                :config="ueditor.config"
                @contentChange="contentChangeFunc"
                ref="ue"
              ></Uediter>
            </div>
          </el-form-item>
        </el-tab-pane>
      </el-tabs>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="onSubmit('dataForm')"
          :loading="loading"
          >提交</el-button
        >
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload
      v-if="isupload"
      :isupload="isupload"
      :type="type"
      @returnImgs="returnImgsFunc"
      >上传图片</Upload
    >
  </div>
</template>

<script>
import codeApi from "@/api/code.js";
import Upload from "@/components/file/Upload";
import Uediter from "@/components/UE.vue";
export default {
  components: {
    Uediter,
    Upload,
  },
  data() {
    var shelvesValidator = (rule, value, callback) => {
      if (this.form.state == 1 && !value) {
        callback(new Error("上架后不能为空"));
        return;
      }
      callback();
    };
    var positiveValidator = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error("必须大于0"));
        return;
      }
      if (!Number.isInteger(Number(value))) {
        callback(new Error("请输入正整数"));
        return;
      }

      callback();
    };
    return {
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {
        name: "",
        sort: 0,
        image_id: "",
        rule_description: "",
        state: 1,
        threshold: 0,
        point_num: 0,
        bonds_price: 0,
        show_type: 1,
        jackpot: "",
        jackpot_reset_num: 0,
        ten_reward: "",
        detail_image_id: "",
        draw_counts: "",
        lottery_image_id: "",
      },
      ueditor: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500,
        },
      },
      activeName: "first",
      childCateList: [],
      category: [],
      file_path: "",

      uploadType: "",
      detail_file_path: "",
      lottery_image: "",
      /*是否上传图片*/
      isupload: false,
      loading: false,
      rules: {
        name: [{ required: true, message: "请填写分类名称", trigger: "blur" }],
        image_id: [
          { required: true, message: "请选择分类封面图片", trigger: "blur" },
        ],
        rule_description: [
          { required: true, validator: shelvesValidator, trigger: "blur" },
        ],
        bonds_price: [
          { required: true, validator: shelvesValidator, trigger: "blur" },
          { required: true, validator: positiveValidator, trigger: "blur" },
        ],
        point_num: [
          { required: true, validator: shelvesValidator, trigger: "blur" },
          { required: true, validator: positiveValidator, trigger: "blur" },
        ],
        draw_counts: [{ required: true, message: "请填写", trigger: "blur" }],

        jackpot: [
          { required: true, validator: shelvesValidator, trigger: "blur" },
        ],
        jackpot_reset_num: [
          { required: true, validator: shelvesValidator, trigger: "blur" },
          { required: true, validator: positiveValidator, trigger: "blur" },
        ],
        ten_reward: [
          { required: true, validator: shelvesValidator, trigger: "blur" },
        ],
        detail_image_id: [
          { required: true, message: "请选择详情图片", trigger: "blur" },
        ],
        lottery_image_id: [
          { required: true, message: "请选择图片", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.form.category_id = this.$route.query.category_id;
    this.getData();
    this.getChildCate();
  },

  methods: {
    changeShowType() {
      this.$refs.dataForm.clearValidate()
    },
    getChildCate() {
      setTimeout(() => {
        codeApi
          .cardType({ parent_id: this.form.category_id }, true)
          .then((data) => {
            let list = [];
            data.data.list.forEach((item, index) => {
              list.push({
                key: index,
                label: item.name,
                value: item.category_id + "",
              });
            });
            this.childCateList = list;
          })
          .catch((error) => {});
      }, 300);
    },
    getData() {
      let self = this;
      codeApi
        .cardType(
          {
            category_id: self.form.category_id,
          },
          true
        )
        .then((res) => {
          self.file_path = res.data.list[0].save_name;
          self.detail_file_path = res.data.list[0].detail_save_name;
          self.lottery_image = res.data.list[0].lottery_save_name;
          self.form.lottery_image_id = res.data.list[0].lottery_image_id;
          self.form.name = res.data.list[0].name;
          self.form.sort = res.data.list[0].sort;
          self.form.image_id = res.data.list[0].image_id;
          self.form.show_type = res.data.list[0].show_type;
          self.form.detail_image_id = res.data.list[0].detail_image_id;
          self.form.rule_description = res.data.list[0].rule_description;
          self.form.state = res.data.list[0].state;
          self.form.threshold = res.data.list[0].threshold
          self.form.bonds_price = res.data.list[0].bonds_price
            ? res.data.list[0].bonds_price
            : 0;
          self.form.point_num = res.data.list[0].point_num
            ? res.data.list[0].point_num
            : 0;
          self.form.jackpot = res.data.list[0].jackpot;
          self.form.jackpot_reset_num = res.data.list[0].jackpot_reset_num
            ? res.data.list[0].jackpot_reset_num
            : 0;
          self.form.ten_reward = res.data.list[0].ten_reward;
          self.form.draw_counts = res.data.list[0].draw_counts;
          this.$nextTick(() => {
            this.$refs.ue.setVal();
          });
        })
        .catch((error) => {});
    },
    /*添加用户*/
    onSubmit(formName) {
      console.info(this.form);
      this.$refs[formName].validate((valid) => {
        console.info(valid);
        if (valid) {
          let self = this;
          let form = self.form;
          self.loading = true;
          self.form.rule_description = this.$refs.ue.getUEContent();
          codeApi
            .cateEdit(form, true)
            .then((data) => {
              self.loading = false;
              self.$message({
                message: "恭喜你，修改成功",
                type: "success",
              });
              self.$router.push("/card/category/index");
            })
            .catch((error) => {
              self.loading = false;
            });
        } else {
          this.$message.error("请完善必填信息");
          return false;
        }
      });
    },

    /*上传*/
    openUpload: function (e, uploadType) {
      this.uploadType = uploadType;
      this.type = e;
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        if (this.uploadType == "3") {
          this.lottery_image = e[0].file_path;
          this.form.lottery_image_id = e[0].file_id;
          return;
        }
        if (this.uploadType == "1") {
          this.file_path = e[0].file_path;
          this.form.image_id = e[0].file_id;
        } else {
          this.detail_file_path = e[0].file_path;
          this.form.detail_image_id = e[0].file_id;
        }
      }
      this.isupload = false;
    },

    contentChangeFunc(e) {
      console.info(e);
      this.form.rule_description = e;
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.basic-setting-content {
}

.product-add {
  padding-bottom: 50px;
}

.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/card/category/edit.vue